module.exports = __webpack_public_path__ + "c70ba2e26749882f79c7dfbfffc514f8.svg";